import { module } from 'modujs';
import { html } from '../utils/environment';
import { gsap } from 'gsap';
import { ScrambleTextPlugin } from "../libs/gsap/ScrambleTextPlugin";

gsap.registerPlugin(ScrambleTextPlugin);


export default class extends module {
    constructor(m) {
        super(m);

		this.events = {
			click: 'toggle',
			mouseenter: {
				wrap: 'hover'
			}
		}

		this.$label = this.$('label')[0];
		this.isHover = false;
    }

    init() {

		this.isOpen = false;
		this.openLabel = this.getData('open-label');
		this.closeLabel = this.getData('close-label');

		this.scramblingOpenDelay = window.isMobile ? 0.1 : 0.3;
		this.scramblingOpenDelayIterator = window.isMobile ? 0.05 : 0.1;

		this.bindOutsideClick = this.outsideClick.bind(this);
		window.addEventListener('click',this.bindOutsideClick);

		this.bindKeydown = this.keydown.bind(this);
		document.addEventListener('keydown',this.bindKeydown);
	}


	keydown(e) {
		if(this.isOpen) {
			if(e.keyCode == 27) {
				this.toggle();
			}
		}
	}

	outsideClick(e) {
		if (this.el.contains(e.target)){
			// Clicked in box
		} else{
			if(this.isOpen) {
				this.toggle();
			}
		}
		
	}

	toggle() {
		this.isOpen = !this.isOpen;

		html.classList.toggle('has-menu-open');
		let metaThemeColor = document.querySelector('[name=theme-color]');

		if(this.isOpen) {
			this.oldThemeColor = metaThemeColor.getAttribute('content');
			
			if(window.isMobile) {
				gsap.delayedCall(0.2,() => {
					metaThemeColor.setAttribute('content','#F0FF3D');
				});
			}

			this.call('hide',{},'MenuButtonLabel','menuOpen');
			this.call('display',0.1,'MenuButtonLabel','menuClose');

			let scrambleModuleIndex = 0;
			Object.entries(this.modules.Scramble).forEach(([key, value], index) => {
				if(key.startsWith('menu')) {
					this.call('display',this.scramblingOpenDelay + this.scramblingOpenDelayIterator * scrambleModuleIndex,'Scramble',key);
					scrambleModuleIndex++;
				}
			});

			this.call('hover',0.6,'Button','contact');

		} else {

			if(window.isMobile) {
				gsap.delayedCall(0.1,() => {
					metaThemeColor.setAttribute('content',this.oldThemeColor);
				});
			}

			this.call('hide',{},'MenuButtonLabel','menuClose');
			this.call('display',0.1,'MenuButtonLabel','menuOpen');

			Object.entries(this.modules.Scramble).forEach(([key, value], index) => {
				if(key.startsWith('menu')) {
					this.call('hide',0.1,'Scramble',key);
				}
			});
		}
	}

	hover(e) {
		if(window.isMobile) return;

		if(!this.isOpen) {			
			this.call('hover',{},'MenuButtonLabel','menuOpen');
		} else {
			this.call('hover',{},'MenuButtonLabel','menuClose');
		}
		
	}

	destroy() {
		document.removeEventListener('keydown',this.bindKeydown);

	}

}
